import { OptionItem } from '../common/option-item';
import { Region } from '../localities/localities';

export interface Metadata {
    toilets: OptionItem[];
    studies: OptionItem[];
    homeAndIncome: OptionItem[];
    regions: Region[];
    bedrooms: OptionItem[];
    propertyAreaUnit: OptionItem[];
    bathrooms: OptionItem[];
    ensuites: OptionItem[];
    lounges: OptionItem[];
    garageParking: OptionItem[];
    offStreetParking: OptionItem[];
    duration: OptionItem[];
    contactTimes: OptionItem[];
    smokers: OptionItem[];
    pets: OptionItem[];
    maxTenants: OptionItem[];
    fees: Fee[];
    openHomeTimes: OptionItem[];
    auctionTimes: OptionItem[];
    saleTypes: OptionItem[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listingExtras: any[]; // TODO: use proper type once confirmed
    premiumPackages: PremiumPackage[];
    partnershipAgreementContents: PartnershipAgreementContents;
    listingEndDate?: Date;
    listingStartDate?: Date;
    listingRelistDate?: Date;
    isWithdrawn: boolean;
    isUntilWithdrawn: boolean; // Indicates if the duration of the listing is until-withdrawn
    privateSellerPackageInformation?: PackageInformation;
}

export interface MotorsMetadata {
    boatLocation: OptionItem[];
    engineMake: OptionItem[];
    engineSizeUnits: OptionItem[];
    engineType: OptionItem[];
    fees: Package[];
    packageInformation: PackageInformation;
    fuelType: OptionItem[];
    hullMaterial: OptionItem[];
    lengthUnits: OptionItem[];
    make: OptionItem[];
    auctionTimes: OptionItem[];
    maxDurationDays?: number;
    minDurationMinutes: number;
    listingEndDate?: Date;
    listingStartDate?: Date;
    listingRelistDate?: Date;
    bidCount: number;
    hasReserveMet: boolean;
    maxBidAmount?: number;
    isListingAfterSevenDays: boolean;
    isWithdrawn: boolean;
    hasBeenExtended: boolean;
}

export interface PackageInformation {
    listingPackageId: number;
    effectiveFeeDeterminer: number;
}

export interface Photo {
    id: number;
    url: string;
    description: string;
    selected: boolean;
}

export interface Detail {
    priority: number;
    checked: boolean;
    description: string;
}

export interface Price {
    id: number;
    minValue: number;
    maxValue: number;
    price: number;
}

export interface Fee {
    id: number;
    name: string;
    description: string;
    photos: Photo[];
    details: Detail[];
    prices: Price[];
    feePrice: number;
    minPhotoRequired: number;
}

export interface PremiumPackage {
    code: string;
    name: string;
    priority: number;
}

export interface PartnershipAgreementContents {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listingExtras: any[];
    premiumPackages: PremiumPackage[];
}

export interface Package {
    id: number;
    name: string;
    minPhotoRequired: number;
    sellingType: number;
    packageUi: PackageUi;
    prices: Price[];
}

export interface CalculatedPackage extends Package {
    isDisabled: boolean;
    packagePrice: number;
}

export interface PackageUi {
    features: string;
    heading: string;
    id: number;
    name: string;
    photos: string;
    subtitle: string;
}
